export default {
	TITLE: 'Juicers',
};
